/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//French (France)
export default {
  'ai-mate.chat-error-banner.description': "Votre historique de chat est conservé jusqu'à 30 jours.",
  'ai-mate.chat-error-banner.title': 'Démarrer un nouveau chat',
  'ai-mate.chat-error.description': 'Essayez de <btn>recharger le chat</btn>.',
  'ai-mate.chat-error.rate-limited-description':
    'Vous avez atteint le nombre maximal de demandes. Veuillez réessayer ultérieurement.',
  'ai-mate.chat-error.rate-limited-title': 'Trop de demandes',
  'ai-mate.chat-error.rovo-inactive-description':
    "Il semble que Rovo n'est pas activé sur votre site. <link>Configurer Rovo</link>",
  'ai-mate.chat-error.rovo-inactive-title': 'Rovo est inactif',
  'ai-mate.chat-error.title': "Nous ne savons pas ce qui s'est passé",
  'ai-mate.main-chat.close-chat-button-label': 'Fermer',
  'ai-mate.main-chat.maximize-chat-button-label': 'Plein écran',
  'ai-mate.main-chat.minimize-chat-button-label': 'Restaurer la vue',
  'ai-mate.main-chat.new-chat-button-label': 'Nouveau',
  'ai-mate.main-chat.new-chat-button-label-full-screen': 'Nouveau chat',
  'conversation-assistant-button.label': 'Chat',
  'conversation-assistant-button.rovo-chat-label': 'Chat Rovo',
  'highlight-actions.rovo-chat-custom-prompt-submit-button.text': 'Envoyer',
  'highlight-actions.rovo-chat-custom-prompt.placeholder': 'Interroger Atlassian Intelligence à ce sujet',
  'highlight-actions.rovo-chat-explain-option.text': 'Expliquer',
  'highlight-actions.rovo-chat-explain-prompt':
    "Expliquez votre préférence en reformulant la phrase et en ajoutant des détails supplémentaires, mais utilisez un langage très simple, des phrases courtes, et donnez des exemples ou une définition à toute terminologie technique utilisée dans la formulation d'origine.",
  'highlight-actions.rovo-chat-find-resources-option.text': 'Rechercher des ressources',
  'highlight-actions.rovo-chat-find-resources-prompt':
    'Trouvez des ressources uniquement dans les connaissances organisationnelles qui valident les déclarations faites.',
  'highlight-actions.rovo-chat-give-examples-option.text': 'Donner des exemples',
  'highlight-actions.rovo-chat-give-examples-prompt':
    "Donnez-en des exemples tirés de ressources organisationnelles ou de connaissances publiques. Si vous n'avez aucune ressource à fournir, essayez de donner un exemple métaphorique qui pourrait aider quelqu'un à mieux comprendre les choses.",
  'highlight-actions.rovo-chat-give-feedback-option.text': 'Envoyer un commentaire',
  'highlight-actions.rovo-chat-give-feedback-prompt':
    'Commentez la formulation. Commentez le choix des mots, la grammaire et la ponctuation. Soyez positif et enthousiaste, mais suggérez toujours au moins un élément à améliorer ou à changer.',
  'highlight-actions.rovo-chat-more-options.tooltip': 'Recommandations de Rovo Chat',
  'highlight-actions.rovo-chat-open-chat.tooltip': 'Ouvrir Rovo Chat',
  'highlight-actions.rovo-chat-summarize-option.text': 'Résumer',
  'highlight-actions.rovo-chat-summarize-prompt':
    'Soulignez les points clés qui en découlent. Concentrez-vous sur les informations essentielles et excluez les informations inutiles. Donnez un aperçu concis en un seul paragraphe.',
  'highlight-actions.rovo-chat.button-text': 'Conversation instantanée',
  'highlight-actions.rovo-chat.button-text-ask-in-chat': 'Demander dans le chat',
  'horizontal-scroll-container.scroll-left': 'Faire défiler vers la gauche',
  'horizontal-scroll-container.scroll-right': 'Faire défiler vers la droite',
};
